var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldMappingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "data-mapping-svgrepo-com",
    d: "M34.689,70.647A14.67,14.67,0,1,0,47.741,91.969h2.431c14.373.171,19.428,4.52,27.467,19.574l.469.853.533,1.024c4.777,8.934,7.485,13.071,12.411,17.463,6.91,6.055,15.824,9.147,27.6,9.147h1.6a14.67,14.67,0,1,0,0-13.412h-2.431c-14.629-.171-19.62-4.691-27.936-20.427h0l-.533-1.023a73.306,73.306,0,0,0-8.274-13.2h39.175a14.67,14.67,0,1,0,0-13.326H47.741a14.63,14.63,0,0,0-12.475-7.975Zm0-50.64A14.67,14.67,0,1,0,47.741,41.329h72.507a14.67,14.67,0,1,0,0-13.326H47.741a14.63,14.63,0,0,0-13.051-8Z",
    transform: "translate(-19.991 -19.994)",
    fill: "#2a2a2a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldMappingIcon);
export default __webpack_public_path__ + "static/media/field-mapping-icon.8d03a88e9673b169df0e205a0be561b3.svg";
export { ForwardRef as ReactComponent };